import Config from '@shared/config/constants/config-main';
import axios from 'axios';

import {
  V5_CHECKMARK_TRIAL,
  V5_CHECKMARK,
  WEB_NEW,
  SPECIAL_SOURCES_FOR_IQ_ZAIN,
} from '@shared/config/constants/api-sources';

import { IQ_ZAIN_OPERATOR } from '@shared/config/constants/app';
import { isIraqZain } from '@entities/operator';
import { isIQ } from '@entities/country';
import { useAtomValue } from 'jotai';
import { dcbAtom, languageAtom } from '@shared/store/slice-atoms';
import { useEffect } from 'react';

const IQ_ZAIN_ANTIFRAUD_SCRIPT_SS_NAME = 'IQ_ZAIN_ANTIFRAUD_SCRIPT';
export const IQ_ZAIN_ANTIFRAUD_ID_SS_NAME = 'IQ_ZAIN_ANTIFRAUD_ID';

export const clearIQZainAntifraudSession = () => {
  sessionStorage.removeItem(IQ_ZAIN_ANTIFRAUD_ID_SS_NAME);
  sessionStorage.removeItem(IQ_ZAIN_ANTIFRAUD_SCRIPT_SS_NAME);
};

export const useIQZainAntifraud = (selectedPlan, isHlrlookup = false) => {
  const language = useAtomValue(languageAtom);
  const dcb = useAtomValue(dcbAtom);
  const { homeData, operator, operatorSelectedDetails } = dcb as any;

  const isIQCountry = isIQ(homeData.country);
  const isIraqZainOperator = isIraqZain(operator.value);
  const isSpecialSource =
    homeData?.source === WEB_NEW ||
    homeData?.source === V5_CHECKMARK ||
    homeData?.source === V5_CHECKMARK_TRIAL ||
    SPECIAL_SOURCES_FOR_IQ_ZAIN?.includes(homeData?.source);

  const shouldReloadPage = operatorSelectedDetails?.shouldReloadPageAfterAntiFraudScript;

  const handleGetAntifraud = async (shouldReloadHlr = false, lookupOperator = null) => {
    const isScriptExists = !!sessionStorage.getItem(IQ_ZAIN_ANTIFRAUD_SCRIPT_SS_NAME);

    if (isScriptExists) {
      if (operatorSelectedDetails?.headerEnrichmentUrl) {
        window.location = operatorSelectedDetails?.headerEnrichmentUrl;
      }

      return;
    }

    const body = {
      country: homeData.country,
      language: language.locale,
      operator: shouldReloadHlr ? IQ_ZAIN_OPERATOR : lookupOperator || operator.value,
      billingOption: selectedPlan,
      source: homeData.source,
      urlReferrer: window.location.href,
      adUrlReferrer: document.referrer || '',
    };

    const res = await axios.post(`${Config.API_URL}/home/antiFraudScript`, body);

    const { script, antiFraudUniqueId, transactionId } = res.data.data || {};
    const uniqueId = antiFraudUniqueId || transactionId;

    if (script) {
      sessionStorage.setItem(IQ_ZAIN_ANTIFRAUD_SCRIPT_SS_NAME, script);
    }

    if (uniqueId) {
      sessionStorage.setItem(IQ_ZAIN_ANTIFRAUD_ID_SS_NAME, uniqueId);
    }

    if (shouldReloadPage || shouldReloadHlr) {
      window.location.reload();
    }
  };

  useEffect(() => {
    if (isHlrlookup) return;

    if (!(isIQCountry && isIraqZainOperator) || isSpecialSource) return;

    handleGetAntifraud();
  }, [isHlrlookup, isIQCountry, isIraqZainOperator]);

  return {
    handleGetZainAntifraudOld: handleGetAntifraud,
    isIraqZainOperator,
    isIQCountry,
  };
};
